import { render, staticRenderFns } from "./Zz.vue?vue&type=template&id=1404bf82&scoped=true&"
import script from "./Zz.vue?vue&type=script&lang=js&"
export * from "./Zz.vue?vue&type=script&lang=js&"
import style0 from "./Zz.vue?vue&type=style&index=0&id=1404bf82&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1404bf82",
  null
  
)

export default component.exports